import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RestService, ApiQueryParams } from '../lib/RestService';
import { setQueryParams } from '../lib/helpers';
import { HttpHeaders } from '@angular/common/http';

export class CartItem {
  PRICE_BASE: number;
  PRICE: number;
  OFFER_ID: string | number;
  PROVIDER_DATA: {
    ITEM_CODE: string | number;
    ACTIVE: 'Y' | 'N';
    BASE_PRICE: number;
    CAN_BUY: 'Y' | 'N';
    CURRENCY: string;
    DETAIL_PAGE_URL: string;
    MEASURE_NAME: string;
    NAME: string;
  };
  QUANTITY: number;
  PRICE_ARR: {
    QUANTITY_FROM: string | null;
  };
}

export class Cart {
  BASKET_PRICE: number;
  BASKET_PRICE_BASE: number;
  DISCOUNT_VALUE: number;
  ITEMS: CartItem[];
}

@Injectable()
export class CartService extends RestService {
  cart: Cart = null;
  private apiUrl = `${environment.apiUrl}shop/Cart/`;

  constructor( private http: HttpClient) {
    super();
    this.updateCart();
  }

  public async updateCart() {
    const cart = await this.get();
    this.cart = Array.isArray(cart) ? null : cart;
    return this.cart;
  }

  public get(params?: ApiQueryParams): Promise<Cart | any> {
    const apiUrl = setQueryParams(this.apiUrl, params);
    return this.http.get<Cart>(apiUrl, {withCredentials: true})
      .toPromise()
      .catch(this.handleError);
  }

  public async add(data: {ID: string | number; QUANTITY: number}): Promise<{result: string; message: string}> {
    try {
      const result = await this.http.post<{result: string; message: string}>(
        this.apiUrl,
        data,
        {withCredentials: true}
      ).toPromise();
      await this.updateCart();
      return result;
    } catch (e) {
      this.handleError(e);
    }
  }

  public async update(data: {ID: string | number; QUANTITY: number}): Promise<{result: string; message: string}> {
    try {
      const result = await this.http.post<{result: string; message: string}>(
        this.apiUrl,
        data,
        {withCredentials: true}
      ).toPromise();
      await this.updateCart();
      return result;
    } catch (e) {
      this.handleError(e);
    }
  }

  public async delete(id: string|number): Promise<{result: string; message: string}> {
    try {
      const result = await this.http.request<{result: string; message: string}>('DELETE', this.apiUrl, {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
        }),
        body: { ID: id }
    }).toPromise();
      await this.updateCart();
      return result;
    } catch (e) {
      this.handleError(e);
    }
  }
}
